import React from "react";

import { Box, Link, Typography } from "@mui/material";

import { WorkflowStepItemProps } from "./type";

export const WorkflowStep: React.FC<WorkflowStepItemProps> = ({
  title,
  content,
  callToAction,
  StepImage,
}) => (
  <Box display="flex" flexDirection="column" alignItems="center" rowGap={1}>
    <StepImage />
    <Typography variant="h5" component="h3">
      {title}
    </Typography>
    <Typography variant="subtitle1" align="center" component="p">
      {content}
    </Typography>
    {callToAction ? (
      <Link href="/login" underline="always" color="secondary">
        {callToAction}
      </Link>
    ) : null}
  </Box>
);
